exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pe-datepicker-container{padding:0 14px;height:36px;box-sizing:border-box;border-radius:3px;font-size:14px;line-height:18px;background-color:#fff;color:#252525;position:relative;display:block;min-width:250px}.pe-datepicker-container svg{position:absolute;top:8px;right:14px;pointer-events:none}.pe-datepicker-container{padding:0;margin-top:6px;width:100%;min-width:150px}.pe-datepicker-input-styles::-ms-clear{display:none}.pe-datepicker-container svg{fill:#6a7070}.pe-icon-wrapper{color:#6a7070}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/DatePicker/DatePicker.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/DatePicker/DatePicker.scss
// module chunks = 0 1 2